import { render } from "./TariffPage.vue?vue&type=template&id=1891f9d0"
import script from "./TariffPage.vue?vue&type=script&lang=js"
export * from "./TariffPage.vue?vue&type=script&lang=js"

import "./TariffPage.vue?vue&type=style&index=0&id=1891f9d0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__